import { render } from "./AiGenerationCategoriesSelection.vue?vue&type=template&id=2aaba876&scoped=true"
import script from "./AiGenerationCategoriesSelection.vue?vue&type=script&lang=js"
export * from "./AiGenerationCategoriesSelection.vue?vue&type=script&lang=js"

import "./AiGenerationCategoriesSelection.vue?vue&type=style&index=0&id=2aaba876&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aaba876"]])

export default __exports__